module.exports = __webpack_public_path__ + "static/img/login_logo.a612ae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login_logo.png
// module id = kmEn
// module chunks = 11